exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tracker-content{\r\n  padding:15px;\r\n  height: auto;\r\n}\r\n\r\n.search-button{\r\n  min-height: 75px;\r\n  width:100%;\r\n  background-color: #4075b3;\r\n  color:white;\r\n  border:none;\r\n  border-radius: 5px;\r\n  text-align: center;\r\n}\r\n\r\n.form-control{\r\n  border-radius:0;\r\n  -webkit-box-shadow: none !important;\r\n          box-shadow: none !important;\r\n  color:black;\r\n  height:30px;\r\n}\r\n\r\n.form-control input{\r\n  -webkit-transition:color 0s;\r\n  transition:color 0s;\r\n}\r\n\r\n.button-col{\r\n  padding-left:0;\r\n}\r\n\r\n.col-dash{\r\n  top:5px;\r\n  color:black;\r\n}", ""]);

// exports
